import numeral from 'numeral';

import { intl } from '~lib/intl';

const DECIMAL_METHODS = {
  round: '0,0',
  decimal: '0,0.00'
};

export const formatPrice = (price, currencySymbol) =>
  `${currencySymbol || intl.currencySymbol} ${numeral(price).format(
    intl.withCents ? DECIMAL_METHODS.decimal : DECIMAL_METHODS.round
  )}`;

export const formatQuantity = (quantity) => `${quantity}x`;

const CENTS = 100;
export const formatToCents = (price) => price * CENTS;

export const isNumber = (n) => typeof n === 'number';
